import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ControlContainer, FormGroupDirective } from '@angular/forms';
import { InputField } from '../../../core/models/input-field';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class InputNumberComponent implements OnInit {
/**
   * * General
   * @errors Form control errors
   * @specificFormGroup Set custom form group
   */
errors: any = {};
specificFormGroup: FormGroup;
/**
 * * Inputs
 * @options Configuration for this form field
 * @customFormGroup Used when you want to use this component without form-builder
 */
@Input() options: InputField;
@Input() customFormGroup: any;
@Input() customFormGroupName: any;

constructor(public controlContainer: ControlContainer) {}

/* ====================================
*              LIFECYCLES
======================================= */

ngOnInit(): void {
  if (this.options.fieldFormGroup || this.options.fieldFormGroup == '') {
    this.specificFormGroup = this.getSpecificFormGroup(
      this.options.fieldFormGroup
    );
  } else {
    this.specificFormGroup = this.customFormGroup;
  }
  if (this.options.fieldFormGroup == '') {
    this.specificFormGroup = this.customFormGroup;
  }
  // this.specificFormGroup = this.options.fieldFormGroup !== '' ? this.getSpecificFormGroup(this.options.fieldFormGroup) : this.customFormGroup;
}

/* ====================================
*                HELPERS
======================================= */

onChange(event: Event) {
  const formGroup = this.controlContainer.control as FormGroup;

  if (this.customFormGroup && this.options.fieldFormGroup !== undefined) {
    this.errors =
      this.customFormGroup.controls[this.options.formControlName].errors;
  } else if (
    this.customFormGroup &&
    (this.options.fieldFormGroup || this.options.fieldFormGroup == '')
  ) {
    this.errors = formGroup.controls[this.options.formControlName].errors;
  } else {
    this.errors = formGroup.controls[this.options.formControlName].errors;
  }

  if (this.options.errorMessage) {
    this.errors = { ...this.errors, errorMessage: this.options.errorMessage };
  }
}

getSpecificFormGroup(formGroupPath: string) {
  return <FormGroup>this.customFormGroup.get(formGroupPath);
}
}
